import { Interactions } from "../core/providers/interactions.provider.tsx";

const MOCK_NOTES = [
  "Port des élastiques classe II — bien respecté.",
  "Léger sur-réservoir 1.6 — surveillance au prochain contrôle.",
  "Demande de rendez-vous décalé en fin de journée.",
];

export function PatientNotesWidget() {
  const { current } = Interactions.usePatient();
  if (!current) {
    return (
      <p className="px-1 text-xs text-sf-text-muted">
        Notes visibles lorsqu'un patient est sélectionné.
      </p>
    );
  }

  return (
    <ul className="flex flex-col gap-2">
      {MOCK_NOTES.map((note, i) => (
        <li
          key={i}
          className="rounded-md border border-sf-border bg-white px-2.5 py-2 text-xs leading-relaxed text-sf-text-secondary"
        >
          {note}
        </li>
      ))}
    </ul>
  );
}
